import { render, staticRenderFns } from "./dropdown-in-place.html?vue&type=template&id=3520e125&scoped=true&"
import script from "./dropdown-in-place.js?vue&type=script&lang=js&"
export * from "./dropdown-in-place.js?vue&type=script&lang=js&"
import style0 from "./dropdown-in-place.css?vue&type=style&index=0&id=3520e125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3520e125",
  null
  
)

export default component.exports